<script>
import { proivderDashboard } from "./data";
export default {
  data() {
    return {
      proivderDashboard: proivderDashboard,
      attributes: [
        {
          key: "today",
          highlight: true,
          dates: new Date(),
        },
      ],
    };
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <div class="page-wrapper">
      <div class="content container-fluid pb-0">
        <div class="row justify-content-center">
          <div class="col-xxl-3 col-md-6">
            <div class="row flex-fill">
              <div class="col-12">
                <div class="card prov-widget">
                  <div class="card-body">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="mb-2">
                        <p class="mb-1">Upcoming Appointments</p>
                        <h5><span class="counter">12</span>+</h5>
                      </div>
                      <span
                        class="prov-icon bg-info d-flex justify-content-center align-items-center rounded"
                      >
                        <i class="ti ti-calendar-check"></i>
                      </span>
                    </div>
                    <p class="fs-12">
                      <span class="text-success me-2"
                        >12% <i class="ti ti-arrow-badge-up-filled"></i></span
                      >from Last Week
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="card prov-widget">
                  <div class="card-body">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="mb-2">
                        <p class="mb-1">Completed Appointments</p>
                        <h5><span class="counter">68</span>+</h5>
                      </div>
                      <span
                        class="prov-icon bg-success d-flex justify-content-center align-items-center rounded"
                      >
                        <i class="ti ti-calendar-check"></i>
                      </span>
                    </div>
                    <p class="fs-12">
                      <span class="text-danger me-2"
                        >12% <i class="ti ti-arrow-badge-down-filled"></i></span
                      >from Last Week
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="card prov-widget">
                  <div class="card-body">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="mb-2">
                        <p class="mb-1">Canceled Appointments</p>
                        <h5><span class="counter">08</span>+</h5>
                      </div>
                      <span
                        class="prov-icon bg-danger d-flex justify-content-center align-items-center rounded"
                      >
                        <i class="ti ti-calendar-check"></i>
                      </span>
                    </div>
                    <p class="fs-12">
                      <span class="text-danger me-2">0%</span>from Last Week
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-md-6">
            <div class="card flex-fill">
              <div class="card-body">
                <div>
                  <div class="d-flex justify-content-center flex-column mb-3">
                    <h5 class="text-center">
                      1,500
                      <span class="text-success"
                        ><i class="ti ti-arrow-badge-up-filled"></i
                      ></span>
                    </h5>
                    <p class="fs-12 text-center">Total earned last week so far</p>
                  </div>
                  <div class="d-flex justify-content-around mb-3">
                    <div>
                      <p class="mb-0">Total Income</p>
                      <h5>$8145</h5>
                    </div>
                    <div>
                      <p class="mb-0">Total Due</p>
                      <h5>$8145</h5>
                    </div>
                  </div>
                  <div id="daily-chart">
                    <apexchart
                      type="bar"
                      height="140"
                      :options="proivderDashboard.provider"
                      :series="proivderDashboard.series"
                    >
                    </apexchart>
                  </div>
                  <div class="d-flex justify-content-center flex-column">
                    <span class="text-success text-center fs-12 mb-4">
                      Performance is 30% better last month
                    </span>
                    <router-link to="/provider/provider-earnings" class="btn btn-dark"
                      >View All Earnings</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-6 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <h6 class="mb-3">Subscription</h6>
                <div class="bg-light-300 rounded p-3 mb-3">
                  <div class="d-flex justify-content-between flex-wrap row-gap-2 mb-2">
                    <span class="badge badge-success"
                      ><i class="ti ti-point-filled"></i>Current Plan</span
                    >
                    <span class="badge bg-info-transparent"
                      >Renewal Date : 14 Jan 2025</span
                    >
                  </div>
                  <div class="mb-2">
                    <p class="mb-0 text-dark fw-medium">Standard Plan</p>
                    <span>Our most popular plan for small teams.</span>
                  </div>
                  <div class="d-flex mb-2">
                    <h5 class="me-2">$291</h5>
                    <span>Per user/Year</span>
                  </div>
                  <div class="">
                    <div class="row justify-content-between">
                      <div class="col-md-6">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-dark w-100 mb-3 mb-md-0"
                          >Upgrade Plan</a
                        >
                      </div>
                      <div class="col-md-6">
                        <a href="javascript:void(0);" class="btn btn-white w-100"
                          >Cancel Plan</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-light-500 rounded p-3">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div class="">
                      <p class="mb-0 text-dark fw-medium">Standard Plan</p>
                      <span class="d-block mb-2"
                        >Our most popular plan for small teams.</span
                      >
                      <router-link to="/provider-subscribtion" class="text-info d-block"
                        >View All Plans</router-link
                      >
                    </div>
                    <div class="d-flex">
                      <h5>$291</h5>
                      <span> /Year</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-md-6 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-4">
                  <h6>Top Services</h6>
                  <router-link to="/details/service-details" class="btn border"
                    >View All</router-link
                  >
                </div>
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="d-flex">
                    <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/services/service-56.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <router-link to="/details/service-details" class="fw-medium mb-0"
                        >Installation Box</router-link
                      >
                      <div
                        class="fs-12 d-flex justify-content-between align-items-center gap-2"
                      >
                        <span class="pe-2 border-end">300 Bookings</span>
                        <span class="pe-2 border-end">$400K</span>
                        <span><i class="ti ti-star-filled text-warning me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <router-link to="/details/service-details">
                    <i class="ti ti-chevron-right"></i>
                  </router-link>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="d-flex">
                    <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/services/service-57.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <router-link to="/details/service-details" class="fw-medium mb-0"
                        >Plumbing Services</router-link
                      >
                      <div
                        class="fs-12 d-flex justify-content-between align-items-center gap-2"
                      >
                        <span class="pe-2 border-end">287 Bookings</span>
                        <span class="pe-2 border-end">$320K</span>
                        <span><i class="ti ti-star-filled text-warning me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <router-link to="/details/service-details">
                    <i class="ti ti-chevron-right"></i>
                  </router-link>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="d-flex">
                    <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/services/service-58.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <router-link to="/details/service-details" class="fw-medium mb-0"
                        >House Renovation</router-link
                      >
                      <div
                        class="fs-12 d-flex justify-content-between align-items-center gap-2"
                      >
                        <span class="pe-2 border-end">250 Bookings</span>
                        <span class="pe-2 border-end">$300K</span>
                        <span><i class="ti ti-star-filled text-warning me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <router-link to="/details/service-details">
                    <i class="ti ti-chevron-right"></i>
                  </router-link>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="d-flex">
                    <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/services/service-59.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <router-link to="/details/service-details" class="fw-medium mb-0"
                        >Painting Services</router-link
                      >
                      <div
                        class="fs-12 d-flex justify-content-between align-items-center gap-2"
                      >
                        <span class="pe-2 border-end">214 Bookings</span>
                        <span class="pe-2 border-end">$280K</span>
                        <span><i class="ti ti-star-filled text-warning me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <router-link to="/details/service-details">
                    <i class="ti ti-chevron-right"></i>
                  </router-link>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="d-flex">
                    <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/services/service-60.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <router-link to="/details/service-details" class="fw-medium mb-0"
                        >Power restoration</router-link
                      >
                      <div
                        class="fs-12 d-flex justify-content-between align-items-center gap-2"
                      >
                        <span class="pe-2 border-end">115 Bookings</span>
                        <span class="pe-2 border-end">$210K</span>
                        <span><i class="ti ti-star-filled text-warning me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <router-link to="/details/service-details">
                    <i class="ti ti-chevron-right"></i>
                  </router-link>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="d-flex">
                    <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/services/service-61.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <router-link to="/details/service-details" class="fw-medium mb-0"
                        >Mosaic Cleaning Service</router-link
                      >
                      <div
                        class="fs-12 d-flex justify-content-between align-items-center gap-2"
                      >
                        <span class="pe-2 border-end">102 Bookings</span>
                        <span class="pe-2 border-end">$190K</span>
                        <span><i class="ti ti-star-filled text-warning me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <router-link to="/details/service-details">
                    <i class="ti ti-chevron-right"></i>
                  </router-link>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="d-flex">
                    <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/services/service-62.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <router-link to="/details/service-details" class="fw-medium mb-0"
                        >Light Installation</router-link
                      >
                      <div
                        class="fs-12 d-flex justify-content-between align-items-center gap-2"
                      >
                        <span class="pe-2 border-end">102 Bookings</span>
                        <span class="pe-2 border-end">$190K</span>
                        <span><i class="ti ti-star-filled text-warning me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <router-link to="/details/service-details">
                    <i class="ti ti-chevron-right"></i>
                  </router-link>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-0">
                  <div class="d-flex">
                    <router-link to="/details/service-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/services/service-63.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <router-link to="/details/service-details" class="fw-medium mb-0"
                        >Cieling Fan Change</router-link
                      >
                      <div
                        class="fs-12 d-flex justify-content-between align-items-center gap-2"
                      >
                        <span class="pe-2 border-end">102 Bookings</span>
                        <span class="pe-2 border-end">$190K</span>
                        <span><i class="ti ti-star-filled text-warning me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <router-link to="/details/service-details">
                    <i class="ti ti-chevron-right"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-md-6 d-flex">
            <div class="card flex-fill">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-4">
                  <h6>Bookings</h6>
                  <a href="javascript:void(0);" class="btn border">View All</a>
                </div>
                <div id="datetimepickershowone" class="datetimepickershowone">
                  <v-calendar :attributes="attributes" />
                </div>
                <div class="book-crd">
                  <div class="card">
                    <div class="card-body">
                      <div
                        class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
                      >
                        <div class="d-flex align-items-center">
                          <router-link
                            to="/booking/booking-details"
                            class="avatar avatar-lg flex-shrink-0 me-2"
                          >
                            <img
                              src="@/assets/img/services/service-63.jpg"
                              class="rounded-circle"
                              alt="Img"
                            />
                          </router-link>
                          <div>
                            <router-link to="/booking/booking-details" class="fw-medium"
                              >Plan & Design</router-link
                            >
                            <span class="d-block fs-12"
                              ><i class="ti ti-clock me-1"></i>05:30 PM - 06:00 PM</span
                            >
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <router-link
                            to="/booking/booking-details"
                            class="avatar avatar-sm me-2"
                          >
                            <img
                              src="@/assets/img/user/user-01.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </router-link>
                          <router-link to="/booking/booking-details">
                            <i class="ti ti-chevron-right"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="book-crd">
                  <div class="card">
                    <div class="card-body">
                      <div
                        class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
                      >
                        <div class="d-flex">
                          <a
                            href="booking-details"
                            class="avatar avatar-lg flex-shrink-0 me-2"
                          >
                            <img
                              src="@/assets/img/services/service-56.jpg"
                              class="rounded-circle"
                              alt="Img"
                            />
                          </a>
                          <div>
                            <router-link to="/booking/booking-details" class="fw-medium"
                              >Installation & Maintenance</router-link
                            >
                            <span class="fs-12 d-block"
                              ><i class="ti ti-clock"></i>04:30 PM - 05:00 PM</span
                            >
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <a href="javascript:void(0);" class="avatar avatar-sm me-2">
                            <img
                              src="@/assets/img/user/user-01.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </a>
                          <router-link to="/booking/booking-details">
                            <i class="ti ti-chevron-right"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="book-crd">
                  <div class="card mb-0">
                    <div class="card-body">
                      <div
                        class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
                      >
                        <div class="d-flex align-items-center">
                          <a
                            href="booking-details"
                            class="avatar avatar-lg flex-shrink-0 me-2"
                          >
                            <img
                              src="@/assets/img/services/service-63.jpg"
                              class="rounded-circle"
                              alt="Img"
                            />
                          </a>
                          <div>
                            <router-link to="/booking/booking-details" class="fw-medium"
                              >Plan & Design</router-link
                            >
                            <span class="d-block fs-12"
                              ><i class="ti ti-clock me-1"></i>05:30 PM - 06:00 PM</span
                            >
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <router-link
                            to="/booking/booking-details"
                            class="avatar avatar-sm me-2"
                          >
                            <img
                              src="@/assets/img/user/user-01.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </router-link>
                          <router-link to="/booking/booking-details">
                            <i class="ti ti-chevron-right"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <provider-location></provider-location>
        </div>
      </div>
    </div>
  </div>
  <provider-dashboard-modal></provider-dashboard-modal>
</template>
